export const addUserErrorMessageMapping: Record<string, string> = {
  'error while creating users: error while creating okta user: The API returned an error: Api validation failed: login. Causes: errorSummary: login: An object with this field already exists in the current organization':
    'Email already exists.',
  'Limit reached to register users':
    'You have reached the maximum number of users allowed for your account. Please upgrade now to add more users.',
}

export const resolveAddUserErrorMessage = (
  errMess: string,
  fallback: string
) => addUserErrorMessageMapping[errMess] || errMess || fallback

export const extractAddUserRows = <T>(rows: { data: T }[]): T[] =>
  rows.map(({ data }) => data)
